/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import './disconnect-on-prem-licensing-modal.component.less';

import {
    Component,
    EventEmitter,
    Output,
} from '@angular/core';

import { AVI_LOAD_BALANCER_LICENSING_GUIDE } from 'ng/modules/licensing/constants';
import { L10nService } from '@vmw/ngx-vip';
import { LicensingService } from 'ajs/modules/licensing';
import * as l10n from './disconnect-on-prem-licensing-modal.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for disconnecting from On-Prem License Hub.
 * @author Shubham Bindal
 */
@Component({
    selector: 'disconnect-on-prem-licensing-modal',
    templateUrl: './disconnect-on-prem-licensing-modal.component.html',
})
export class DisconnectOnPremLicensingModalComponent {
    @Output()
    public onClose = new EventEmitter<void>();

    @Output()
    public onConfirm = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    public forceDisconnectChecked = false;

    public busy = false;

    constructor(
        private readonly l10nService: L10nService,
        private readonly licensingService: LicensingService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Handle cancel/close button click.
     */
    public handleCancel(): void {
        this.onClose.emit();
    }

    /**
     * Handle force disconnect button click.
     */
    public handleForceDisconnect(): void {
        this.onConfirm.emit();
    }

    /**
     * Handle KB link click.
     */
    public handleKbLinkClick($event: Event): void {
        $event.preventDefault();
        window.open(AVI_LOAD_BALANCER_LICENSING_GUIDE, '_blank');
    }
}
